export default {
  primary: {
    main: '#f26722',
    light: 'rgb(242, 103, 34, 0.12)'
  },
  secondary: {
    main: '#05749d',
    light: '#00b2d2'
  },
  info: {
    main: '#0a0a0a'
  }
}
